import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import CurrencyFormat from 'react-number-format';
import useWindowSize from '../../../hooks/useWindowSize';
import { BootstrapBreakpoints } from '../../../utils/constants';
import { dateFormatter } from '../../../utils/dateHelper';
import { useInvestmentNoteDispatch } from '../../../contexts/InvestmentNoteContext';
import { useDict } from '../../../contexts/LanguageContext';
import CancelWithdrawalModal from './CancelWithdrawalModal';
import { useState } from 'react';

const TransactionStatus = {
    Pending: null,
    Approved: 1,
    Rejected: 0,
};

const TransactionCard = (props) => {
    const {
        activityName,
        amount,
        date,
        status,
        investmentNote,
        flow,
        flowId,
    } = props;

    const dict = useDict();
    const language = localStorage.getItem('language') === 'en' ? 'en' : 'th';

    const [isCancelWithdrawalModalOpen, setIsCancelWithdrawalModalOpen] = useState(false);

    const handleOpenCancelWithdrawalModal = () => {
        setIsCancelWithdrawalModalOpen(true);
    };

    const handleCloseCancelWithdrawalModal = () => {
        setIsCancelWithdrawalModalOpen(false);
    };

    const { width } = useWindowSize();
    const isMobile = width <= BootstrapBreakpoints.MD;

    const investmentNoteDispatch = useInvestmentNoteDispatch();

    const getColor = (f, s) => {
        if (s === 'approved') {
            if (f === 'outFlow') {
                return '#FF1E62';
            }
            if (f === 'inFlow') {
                return '#00B212';
            }
        }
        return 'grey';
    };

    const getPrefix = (f, s) => {
        if (s === 'approved') {
            if (f === 'outFlow') {
                return '- ฿ ';
            }
            if (f === 'inFlow') {
                return '+ ฿ ';
            }
        }
        return '฿';
    };

    const getStatus = (s) => {
        switch (s) {
            case TransactionStatus.Pending:
                return dict.pendingApproval;
            case TransactionStatus.Approved:
                return dict.approved;
            default:
                return dict.rejected;
        }
    };

    const getStatusColor = (s) => {
        switch (s) {
            case TransactionStatus.Rejected:
                return 'text-danger';
            case TransactionStatus.Approved:
                return 'text-success';
            default:
                return '';
        }
    };

    const renderDate = () => <span style={{ fontWeight: 'bold' }}>{dateFormatter(date, language)}</span>;

    const renderReference = () => (
        <span style={{ display: 'block' }}>
            {investmentNote ? (
                <span
                    style={{
                        color: '#226EF4',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textUnderlineOffset: '3px',
                    }}
                    onClick={() => investmentNoteDispatch({ type: 'viewInvestmentNoteDetails', investmentNote: investmentNote })}
                    aria-hidden
                >
                    <u>{investmentNote.name}</u>
                </span>
            ) : (
                investmentNote.name
            )}
        </span>
    );

    const renderActivityName = () => (
        <span style={{ fontWeight: 'bold', color: '#4000AE' }}>
            {activityName}
        </span>
    );

    const renderAmount = () => (
        <span
            style={{
                fontWeight: 700,
                color: getColor(flow, status),
                textAlign: 'right',
            }}
        >
            <CurrencyFormat
                value={parseFloat(amount).toFixed(2)}
                displayType="text"
                thousandSeparator
                prefix={getPrefix(flow, status)}
            />
        </span>
    );

    const renderStatus = () => (
        <span
            className={`p-0 font-weight-bold flex-justify-content-center ${getStatusColor(status)}`}
        >
            {activityName === 'Withdrawal' && status === null ? (
                <Button
                    type="submit"
                    className="btn btn-withdrawal rounded mb-0"
                    onClick={handleOpenCancelWithdrawalModal}
                >
                    {dict.cancel}
                </Button>
            ) : (
                <span>
                    {getStatus(status)}
                </span>
            )}
        </span>
    );

    if (isMobile) {
        return (
            <Card className="mb-2">
                <CardBody>
                    <Row className="g-0">
                        <Col xs={7}>
                            <div data-cy="transactionDate">{renderDate()}</div>
                            <div>{renderReference()}</div>
                            <div data-cy="transactionActivityName">
                                {renderActivityName()}
                            </div>
                            <div className="text-left">{renderStatus()}</div>
                        </Col>
                        <Col
                            xs={5}
                            className="d-flex align-items-center justify-content-end"
                        >
                            <div>{renderAmount()}</div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        );
    }
    return (
        <>
            <Card className="grid">
                <CardBody>
                    <Row className="g-0">
                        <Col
                            md={2}
                            sm={12}
                            data-cy="transactionDate"
                            className="d-flex flex-column justify-content-center align-items-stretch text-left"
                        >
                            {renderDate()}
                        </Col>
                        <Col
                            md={2}
                            sm={12}
                            className="d-flex flex-column justify-content-center align-items-stretch text-left"
                        >
                            {renderReference()}
                        </Col>
                        <Col
                            md={3}
                            data-cy="transactionActivityName"
                            className="d-flex flex-row justify-content-center align-items-stretch text-left"
                        >
                            {renderActivityName()}
                        </Col>
                        <Col
                            md={2}
                            sm={12}
                            className="d-flex flex-column justify-content-center align-items-stretch text-center"
                        >
                            {renderStatus()}
                        </Col>
                        <Col
                            md={2}
                            sm={12}
                            className="d-flex flex-column justify-content-center align-items-stretch text-right"
                        >
                            {renderAmount()}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <CancelWithdrawalModal
                isOpen={isCancelWithdrawalModalOpen}
                handleClose={handleCloseCancelWithdrawalModal}
                flowId={flowId}
            />
        </>
    );
};

export default TransactionCard;
